import { Link, useNavigate } from "react-router-dom";
import { userWishlist } from "../userSlice";
import { useSelector, useDispatch } from "react-redux";
import { removeItemFromUserWishlistAsync } from "../userSlice";
import { loggedInUser } from "../../Auth/Auth_Slice";
import toast from "react-hot-toast";
import { isLoadingUserSlice } from "../userSlice";
import Loader from "../../../components/Common/Loader";

const formatNumber = (number) => {
    if (number) {
        let x = number;
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    }
}

function UserWishlist() {

    const wishlist = useSelector(userWishlist);
    const loading = useSelector(isLoadingUserSlice);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(loggedInUser);



    const handleRemoveFromWishlist = (productId) => {
        if (user && user?.isAuthenticated && productId !== null) {
            dispatch(removeItemFromUserWishlistAsync(productId)).then((response) => {
                if (response.payload.status === 'success') {
                    toast.success("Product removed from Wishlist.", { id: "success" })
                } else {
                    toast.error(response.payload.message, { id: "error" })
                }
            });
        } else {
            navigate("/login")
        }
    }

    return (loading ?
        (<div className="w-full flex justify-center px-2 md:px-4 py-5">
            <Loader />
        </div>)
        :
        wishlist && wishlist?.length > 0 ?
            (<div className="inline-block min-w-full rounded-lg overflow-hidden space-y-2 px-6 py-5">
                <p className="text-base font-bold tracking-tight text-gray-900">My Wishlist ({wishlist.length})</p>
                <table className="min-w-full leading-normal">
                    <tbody>
                        {wishlist.map(item => (
                            <tr key={item?.id} className="border-b border-gray-200 last:border-b-0">
                                <td className="px-1 md:px-5 py-5  bg-white text-sm">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0 w-14 h-14">
                                            <img className="w-full h-full" src={item.images[0]} alt={item.imageAlt} />
                                        </div>
                                        <div className="ml-5 w-full">
                                            <div className="flex justify-between w-full">
                                                <p className="text-gray-700 text-sm font-medium text-limit-singleLine">
                                                    {item.name}
                                                </p>
                                                <Link onClick={() => handleRemoveFromWishlist(item.productId)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 ms-6"> <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clipRule="evenodd" /> </svg></Link>
                                            </div>
                                            <div className="py-1 flex items-baseline">
                                                <h2 className="font-medium text-gray-900 tracking-normal text-base">₹{formatNumber(item.price)}</h2>
                                                <h3 className="px-2 font-medium text-gray-500 tracking-normal line-through text-xs">₹{formatNumber(item.originalPrice)}</h3>
                                                <h4 className='font-semibold positive-green-color tracking-tight text-xs'>{100 - (Math.round((item.price / item.originalPrice) * 100))}% Off</h4>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>)
            : (
                <div className="flex py-10 justify-center flex-col basis-full items-center space-y-2">
                    <img src="/no-product.svg" alt="no review-rating" className="w-44" />
                    <div className="space-y-2 text-center">
                        <p className="text-xl font-medium tracking-tight text-gray-900">No Product's In Wishlist.</p>
                        <p className="text-sm font-medium tracking-tight text-gray-600">Looks like you haven't add items in wishlist yet!</p>
                    </div>
                </div>)

    );
}

export default UserWishlist;